import { EyeOff } from "components/icons/icn-eye-off.icons";
import type { PropsWithChildren } from "react";
import { BadgeButton } from "./styled";

export interface BadgeButtonTableProps {
  readonly ariaPressed?: boolean | "false" | "mixed" | "true";
  readonly onClick?: () => void;
}

const BadgeButtonTable = (props: PropsWithChildren<BadgeButtonTableProps>) => {
  const { children, ariaPressed, onClick } = props;

  return (
    <BadgeButton aria-pressed={ariaPressed} onClick={onClick}>
      <EyeOff />
      {children}
    </BadgeButton>
  );
};

export default BadgeButtonTable;
